const CustomerSalesOrder = {

    // FIELDS
    "customer_information": "معلومات العميل",
    "type": "النوع",
    "vehicle": "المركبة",
    "customer": "العميل",
    "sale_type": "نوع البيع",
    "currency": "العملة",
    "order_booked_by": "تم حجز الطلب بواسطة",
    "booking_date": "تاريخ الحجز",
    "delivery_date": "تاريخ التسليم",
    "delivery_type": "نوع التسليم",
    "delivery_terms": "شروط التسليم",
    "payment_terms": "شروط الدفع",
    "customer_po_number": "رقم طلب العميل",
    "customer_po_date": "تاريخ طلب العميل",
    "designation": "التعيين",
    "quotation_code": "كود العرض",
    "credit_days": "أيام الائتمان",
    "our_code_customer_end": "الكود الخاص بنا في نهاية العميل",
    "remark": "ملاحظة",
    "dispatch_address": "عنوان الشحن",
    "dispatch_address_id": "هوية عنوان الشحن",
    "currency_id": "هوية العملة",

    "item_information": "معلومات البند",
    "item": "البند",
    "rate": "السعر",
    "quantity": "الكمية",
    "unit": "الوحدة",
    "discount": "الخصم (%)",
    "vat": "VAT (%)",
    "sub_total": "المجموع الفرعي",
    "total": "الإجمالي",
    "total_weight": "الوزن الإجمالي",
    "search": "بحث",

    // PAGE HEADER
    "sales_order": "أمر البيع",

    // SWEET ALERT
    "filter_alert": "اختر تاريخ التوصيل",
    "repeated_item": "عنصر مكرر",
    "already_exist": "العنصر موجود بالفعل. قم بتحديث كميته",

    // ERROR
    "error_customer": "اختر العميل",
    "error_type": "اختر النوع",
    "error_vehicle": "اختر المركبة",
    "error_address": "اختر العنوان",
    "error_currency": "اختر العملة",
    "error_user": "اختر المستخدم",
    "error_booking_date": "اختر تاريخ الحجز",
    "error_delivery_date": "اختر تاريخ التسليم",
    "error_delivery_type": "اختر نوع التسليم",
    "error_po_number": "أدخل رقم طلب العميل",
    "error_po_date": "اختر تاريخ طلب العميل",
    "error_item": "اختر البند",
    "error_rate": "أدخل السعر",
    "error_quantity": "أدخل الكمية",
    "error_unit": "اختر الوحدة",
    "error_discount": "أدخل الخصم",
    "error_vat": "أدخل ضريبة القيمة المضافة",
    "error_positive": "أدخل قيمة موجبة فقط",
    "error_sales_type": "اختر نوع البيع",
    "error_delivery_terms": "أدخل شروط التسليم",
    "error_payment_terms": "أدخل شروط الدفع",
    "error_designation": "أدخل التعيين",
    "error_quotation_code": "أدخل كود العرض",
    "error_credit_days": "أدخل أيام الائتمان",
    "error_code": "أدخل الكود",
    "error_remark": "أدخل الملاحظة",

    // TABLE HEADER
    "table_sales_order_code": "كود طلب المبيعات",
    "table_booking_date": 'تاريخ الحجز',
    "table_delivery_date": 'تاريخ التسليم',
    "table_total_item": "البند الإجمالي",
    "table_total_value": "إجمالي القيمة",
    "table_customer": "العميل",
    "table_van_sale": "بيع فان",
    "table_city": "المدينة",
    "table_status": "الحالة",

    // DISPATCH ADVICE ROUTES
    "dispatch_advice": "نصيحة الإرسال",
    "da_route_planning": "تخطيط مسار نصيحة الإرسال",
    "route": "مسار",
    "default_route": "المسار الافتراضي",
    "action": "إجراء",

    // ERROR FOR SALES ORDER ROUTES
    "error_dispatch_advice": "اختر نصيحة الإرسال",
    "error_route": "اختر المسار",
    "error_dispatch_advice_not_found": "لم يتم العثور على نصيحة الإرسال",

}

export default CustomerSalesOrder;